import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalShell = ({ title, children, testId }) => (
  <div
    data-testid={testId}
    className="min-h-screen"
    style={{ background: '#0D1F17', color: '#F5EFE3' }}
  >
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '32px 20px 80px' }}>
      <Link
        to="/"
        data-testid="legal-back-link"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          color: 'rgba(245, 239, 227, 0.6)',
          fontSize: 14,
          textDecoration: 'none',
          marginBottom: 24,
        }}
      >
        <ArrowLeft size={16} />
        Retour à l&rsquo;accueil
      </Link>
      <h1
        style={{
          fontFamily: 'Inter, system-ui, sans-serif',
          fontWeight: 800,
          fontSize: 32,
          lineHeight: 1.15,
          letterSpacing: '-0.02em',
          marginBottom: 24,
        }}
      >
        {title}
      </h1>
      <div
        style={{
          fontSize: 14,
          lineHeight: 1.7,
          color: 'rgba(245, 239, 227, 0.75)',
        }}
      >
        {children}
      </div>
    </div>
  </div>
);

const H2 = ({ children }) => (
  <h2
    style={{
      fontFamily: 'Inter, system-ui, sans-serif',
      fontWeight: 700,
      fontSize: 18,
      color: '#F5EFE3',
      marginTop: 28,
      marginBottom: 10,
    }}
  >
    {children}
  </h2>
);

const P = ({ children }) => (
  <p style={{ marginBottom: 12 }}>{children}</p>
);

export const MentionsLegales = () => (
  <LegalShell title="Mentions légales" testId="mentions-legales-page">
    <H2>Éditeur du site</H2>
    <P>
      Le présent site est édité par <strong>Hustler Digital Academy</strong>, entreprise individuelle
      représentée par Samba Kaba, joignable à l&rsquo;adresse email :
      <strong> contact@hustlerdigitalacademy.com</strong>.
    </P>

    <H2>Hébergement</H2>
    <P>
      Le site est hébergé par Emergent (infrastructure Kubernetes / cloud sécurisé). Les données
      sont stockées sur des serveurs conformes aux exigences du RGPD.
    </P>

    <H2>Propriété intellectuelle</H2>
    <P>
      L&rsquo;ensemble des contenus présents sur ce site (textes, vidéos, images, logos, éléments
      graphiques) sont la propriété exclusive de Hustler Digital Academy. Toute reproduction,
      représentation, modification ou publication, totale ou partielle, est strictement
      interdite sans autorisation écrite préalable.
    </P>

    <H2>Responsabilité</H2>
    <P>
      Les informations diffusées sur ce site sont fournies à titre indicatif. Hustler Digital
      Academy ne saurait être tenu responsable des erreurs, d&rsquo;une absence de disponibilité
      des fonctionnalités ou de la présence de virus sur son site.
    </P>

    <H2>Contact</H2>
    <P>
      Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter à
      l&rsquo;adresse : contact@hustlerdigitalacademy.com
    </P>
  </LegalShell>
);

export const PolitiqueConfidentialite = () => (
  <LegalShell title="Politique de confidentialité" testId="politique-confidentialite-page">
    <H2>Données collectées</H2>
    <P>
      Dans le cadre de la réservation d&rsquo;un appel stratégique ou d&rsquo;un accès à nos
      contenus, nous collectons les données suivantes : nom, prénom, adresse email, numéro de
      téléphone (WhatsApp), pseudo Instagram, tranche d&rsquo;âge, situation professionnelle.
    </P>

    <H2>Finalité du traitement</H2>
    <P>
      Ces données sont utilisées pour :
    </P>
    <ul style={{ marginLeft: 20, marginBottom: 12 }}>
      <li>Organiser et confirmer votre rendez-vous</li>
      <li>Vous envoyer des communications relatives à nos formations et accompagnements</li>
      <li>Améliorer nos services et notre offre</li>
    </ul>

    <H2>Durée de conservation</H2>
    <P>
      Vos données sont conservées pendant une durée maximale de 3 ans à compter de votre dernier
      contact avec nous, sauf demande de suppression de votre part.
    </P>

    <H2>Partage des données</H2>
    <P>
      Vos données ne sont jamais vendues à des tiers. Elles peuvent être partagées avec nos
      sous-traitants techniques (Google Calendar pour les rendez-vous, Brevo pour les envois
      email) dans le strict cadre de l&rsquo;exécution du service.
    </P>

    <H2>Vos droits (RGPD)</H2>
    <P>
      Conformément au Règlement Général sur la Protection des Données, vous disposez d&rsquo;un
      droit d&rsquo;accès, de rectification, de suppression, d&rsquo;opposition et de portabilité
      de vos données. Vous pouvez exercer ces droits en écrivant à :
      <strong> contact@hustlerdigitalacademy.com</strong>.
    </P>

    <H2>Cookies</H2>
    <P>
      Ce site utilise Google Tag Manager et Google Analytics pour mesurer l&rsquo;audience et
      améliorer l&rsquo;expérience utilisateur. Vous pouvez désactiver ces cookies via les
      paramètres de votre navigateur.
    </P>
  </LegalShell>
);

export const CGV = () => (
  <LegalShell title="Conditions générales de vente" testId="cgv-page">
    <H2>Objet</H2>
    <P>
      Les présentes conditions générales de vente (CGV) régissent la vente des prestations
      d&rsquo;accompagnement et de formation proposées par Hustler Digital Academy.
    </P>

    <H2>Prestations proposées</H2>
    <P>
      Hustler Digital Academy propose des accompagnements individuels et collectifs visant à
      aider les entrepreneurs à développer un business digital rentable. Les modalités précises
      (durée, contenu, tarif) sont détaillées lors de l&rsquo;appel stratégique préalable.
    </P>

    <H2>Tarifs et paiement</H2>
    <P>
      Les tarifs sont communiqués lors de l&rsquo;appel stratégique. Le paiement peut être
      effectué en une fois ou selon un échéancier convenu avec le client. Tout accompagnement
      commence après réception du premier paiement.
    </P>

    <H2>Droit de rétractation</H2>
    <P>
      Conformément à l&rsquo;article L.221-28 du Code de la consommation, le droit de
      rétractation ne peut être exercé pour les prestations pleinement exécutées avant la fin du
      délai de rétractation et dont l&rsquo;exécution a commencé avec l&rsquo;accord préalable
      exprès du consommateur.
    </P>

    <H2>Obligations du client</H2>
    <P>
      Le client s&rsquo;engage à participer activement aux sessions d&rsquo;accompagnement, à
      appliquer les recommandations transmises et à fournir les informations nécessaires au bon
      déroulement de la prestation. Les résultats dépendent directement de son implication.
    </P>

    <H2>Absence de garantie de résultats</H2>
    <P>
      Hustler Digital Academy s&rsquo;engage à mettre en œuvre tous les moyens nécessaires pour
      accompagner le client dans son projet, sans pouvoir garantir un résultat financier
      spécifique. Les résultats communiqués (études de cas, témoignages) sont des exemples et ne
      constituent pas une promesse de gains.
    </P>

    <H2>Litiges</H2>
    <P>
      Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable
      sera recherchée avant toute action judiciaire.
    </P>
  </LegalShell>
);
